import {
  showMessage,
  stringToHTML,
  debounce,
  getResponseByMode,
  isVisible
} from './utils';

export const deliveryData = {
  init: function () {
    this._deliveryContainer = document.querySelector('.delivery-product__wrapper');
    this._data = null;
    this._load = debounce(this._load.bind(this));
    this._documentLoadAndScrollHandler = this._documentLoadAndScrollHandler.bind(this);


    document.addEventListener('scroll', this._documentLoadAndScrollHandler);
    document.addEventListener('DOMContentLoaded', this._documentLoadAndScrollHandler);
  },

  _documentLoadAndScrollHandler: function () {
    if (this._deliveryContainer && isVisible(this._deliveryContainer)) {
      this._load();
    }
  },

  _load: async function () {
    try {
      const mock = 'mocks/delivery-table.html';
      const real = window.location.origin + '/index.php?option=com_jshopping&controller=product&task=getshippingMethod';
      const url = getResponseByMode(mock, real);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Неуспешный запрос');
      }
      const html = await response.text();
      const doc = stringToHTML(html);
      this._data = doc;
      this._insertTable();

      document.removeEventListener('scroll', this._documentLoadAndScrollHandler);
      document.removeEventListener('DOMContentLoaded', this._documentLoadAndScrollHandler);

    } catch (error) {
      showMessage(error.message);
    }
  },

  _insertTable: function () {
    const deliveryList = this._data.querySelector('.delivery-product__table');
    this._deliveryContainer.innerHTML = '';
    this._deliveryContainer.append(deliveryList);
  },
};
